var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundTel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 1145.898,
    viewBox: "0 0 500 1145.898",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 1,
    x2: 0,
    y2: 1.081,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7970fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7791fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x2: 0.958,
    y2: 0.079,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7791fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7970fc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "backTel1",
    transform: "translate(0.004)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_57",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 57",
    width: 499.995,
    height: 922.657,
    transform: "translate(0.001)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_393",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 393",
    transform: "translate(-0.004 908.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u0412\\u044B\\u0447\\u0438\\u0442\\u0430\\u043D\\u0438\\u0435_4",
    "data-name": "\\u0412\\u044B\\u0447\\u0438\\u0442\\u0430\\u043D\\u0438\\u0435 4",
    d: "M411.269,133.271h-.017c-8.557,0-17.353-.325-26.145-.967-9.432-.688-19.112-1.76-28.772-3.184-10.292-1.519-20.837-3.479-31.345-5.827-11.135-2.489-22.533-5.481-33.866-8.895-38.98-11.733-82.194-17.69-128.441-17.69a602.654,602.654,0,0,0-101.708,8.933c-12.521,2.152-24.948,4.675-36.933,7.5C13.4,115.639,5.095,117.917,0,119.388V21.052L499.995,0V119.865c-2.835.967-5.781,1.9-8.759,2.767a254.741,254.741,0,0,1-33.724,7.308c-7.016,1.047-14.281,1.857-21.592,2.409C427.881,132.961,419.586,133.269,411.269,133.271Z",
    transform: "translate(0.005 103.803)",
    fill: "#7889fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0412\\u044B\\u0447\\u0438\\u0442\\u0430\\u043D\\u0438\\u0435_5",
    "data-name": "\\u0412\\u044B\\u0447\\u0438\\u0442\\u0430\\u043D\\u0438\\u0435 5",
    d: "M440.447,200.531h0a15.374,15.374,0,0,1-9.9-3.489,21.21,21.21,0,0,1-3.967-4.305,33.426,33.426,0,0,1-3.288-5.961,68.312,68.312,0,0,1-4.463-16.745,154.889,154.889,0,0,1-1.521-22.922,46.782,46.782,0,0,0-.8-8.879,32.91,32.91,0,0,0-2.285-7.3,26.641,26.641,0,0,0-3.6-5.845,26.089,26.089,0,0,0-4.761-4.511c-6.429-4.725-15.615-7.12-27.3-7.12a126.622,126.622,0,0,0-24.524,2.731A223.585,223.585,0,0,0,331,122.189c-7.163,2.256-13.248,4.512-17.092,6.008-4.169,1.621-6.667,2.721-6.688,2.731-.144.1-3.584,2.491-9.42,5.976-3.481,2.08-7.129,4.14-10.841,6.125-4.635,2.479-9.379,4.84-14.1,7.021a231.739,231.739,0,0,1-35.48,13.147,176.222,176.222,0,0,1-20.133,4.333,139.642,139.642,0,0,1-20.9,1.645h-.009a115.947,115.947,0,0,1-13.363-.759,102.3,102.3,0,0,1-13.271-2.429,93.754,93.754,0,0,1-13.012-4.329,90.776,90.776,0,0,1-12.6-6.457c-3.733-2.3-7.667-4.472-11.681-6.448-3.856-1.9-7.892-3.671-12-5.267-3.936-1.529-8.039-2.933-12.2-4.185-3.971-1.192-8.1-2.267-12.267-3.2a217.894,217.894,0,0,0-47.419-4.968c-8.323,0-16.882.415-25.444,1.232-6.849.653-13.717,1.565-20.413,2.709-.893.153-1.8.312-2.681.472V0L497.667,4.705h0c.1.2,1,1.961,2.329,5V145.3a117.193,117.193,0,0,1-6.347,9.9c-10.779,15.082-20.876,26.61-30.01,34.266C454.875,196.8,447.073,200.531,440.447,200.531Z",
    transform: "translate(0.004 0)",
    fill: "url(#linear-gradient-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundTel);
export default __webpack_public_path__ + "static/media/backgroundTel.35ca1af61116d047b73173f901eb62c2.svg";
export { ForwardRef as ReactComponent };